export default {
  beforeMount(el, binding) {
    if (process.env.NODE_ENV !== "production") {
      el.setAttribute("data-test-id", binding.value);
    }
  },
};
